import { parsePermission, updateAbility, useAbility } from '@nordvpn/teams.core/lib/atoms/Permissions';
export var usePermission = function usePermission(permission) {
    var ability = useAbility();
    var _parsePermission = parsePermission(permission), action = _parsePermission.action, subject = _parsePermission.subject;
    return ability.can(action, subject);
};
export var updatePermissions = function updatePermissions(data) {
    var roleEnabledUser = {
        role: {
            identifier: '',
            title: '',
            permissions: data.map(function (_ref) {
                var identifier = _ref.identifier;
                return identifier;
            })
        }
    };
    updateAbility(roleEnabledUser);
};
